import { RouterModule, Routes } from "@angular/router";
import { SuporteLocalListComponent } from "./components/suporte-local-list/suporte-local-list.component";
import { SuporteLocalEditComponent } from "./components/suporte-local-edit/suporte-local-edit.component";
import { SuporteUsuarioListComponent } from "./components/suporte-usuario-list/suporte-usuario-list.component";
import { SuporteUsuarioViewComponent } from "./components/suporte-usuario-view/suporte-usuario-view.component";
import { SuporteGeralListComponent } from "./components/suporte-geral-list/suporte-geral-list.component";
import { SuporteGeralEditComponent } from "./components/suporte-geral-edit/suporte-geral-edit.component";

const routes: Routes = [
  {
    path: 'local',
    children: [
      {
        path: '',
        component: SuporteLocalListComponent,
      },
      {
          path: ':type/:id',
          component: SuporteLocalEditComponent
      }
    ]
  },
  {
    path: 'geral',
    children: [
      {
        path: '',
        component: SuporteGeralListComponent,
      },
      {
          path: ':type/:id',
          component: SuporteGeralEditComponent
      }
    ]
  },
  {
    path: 'meus-suportes',
    children: [
      {
        path: '',
        component: SuporteUsuarioListComponent,
      },
      {
          path: ':type/:id',
          component: SuporteUsuarioViewComponent
      }
    ]
  }
];

export const ChatBotRoutes = RouterModule.forChild(routes);
